import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import { CollapseIcon, ExpandIcon } from "./icons";

export interface FaqType {
  answer: string;
  id: string;
  question: string;
}

type FaqItemProps = FaqType;

export default function FaqItem({ answer, id, question }: FaqItemProps) {
  return (
    <AccordionItem
      className="mb-2 rounded-[15px] border-0 bg-eerie-black md:mb-[25px] md:rounded-[30px]"
      value={id}
    >
      <AccordionTrigger className="group flex min-h-[50px] items-center justify-between px-2.5 py-[15px] font-medium text-13/[1.54em] text-white hover:no-underline md:min-h-[94px] md:p-8 md:text-24/[1.25em]">
        {question}
        <CollapseIcon className="ml-2.5 group-data-[state=closed]:hidden md:w-6" />
        <ExpandIcon className="ml-2.5 group-data-[state=open]:hidden md:size-6" />
      </AccordionTrigger>
      <AccordionContent className="p-[15px] pt-0 md:p-8 md:pt-0">
        <p className="text-13/[2.31em] text-pale-lavender md:text-16/[1.88em]">
          {answer}
        </p>
      </AccordionContent>
    </AccordionItem>
  );
}
